import { newHttpService } from "../../services/new-http-service"

export interface ObjectiveSequenceStatus {
    allowed: boolean
    current_max_objective_number: number
    expected_next_objective_number: number
    missing_objective_numbers: number[]
    message: string
}

export const checkObjectiveSequence = async (objectiveNumber: number): Promise<ObjectiveSequenceStatus> => {
    return newHttpService.get('/api/backoffice/objective-sequence-check', {
        objective_number: objectiveNumber,
    }) as Promise<ObjectiveSequenceStatus>
}
